/**
 * Treat a missing scheme as https rather than an error.
 *
 * "mybusiness.com" is what a customer types into the first field of
 * onboarding. Rejecting it there stalls the path we label Recommended, so the
 * scheme is added for them instead of being demanded.
 */
export const normaliseUrl = (raw) => {
  const trimmed = (raw || '').trim();
  if (!trimmed || /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export default normaliseUrl;
